import React from 'react';
import User from 'records/User';
import hasFlag from 'utils/hasFlag';
import {featureFlags} from 'utils/const';
import ToggleField from 'components/pure/utils/form/ToggleField';

export default function EditRecordingSettingsForm(props: {
  user: User;
  onEditUser: (u: User) => void;
}) {
  const {user, onEditUser} = props;
  const onToggle = (_, val) => {
    onEditUser(user.set('botAutoJoinExclusion', !val));
  };
  return (
    <div className="recording">
      <h2>Recording</h2>

      <div className="form-grouper integrations-form">
        <div className="title">Automated Recording</div>
        <div>
          <ToggleField
            toggled={!props.user.botAutoJoinExclusion}
            onToggle={onToggle}
            label="Record scheduled calls"
          />
        </div>
        <div className={'description'}>
          Internal meetings {hasFlag(featureFlags.doNotRecordInternalMeetings) ? 'won’t' : 'will'}{' '}
          be recorded. To change this, please talk to your administrator.
        </div>
      </div>
    </div>
  );
}
